// apps/dashboard/src/hooks/use-dunning.ts
// TanStack Query hook — fetches current dunning status for the authenticated tenant.
// SPEC: docs/specs/billing/sprint-an-dunning.spec.md

import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';

export type DunningStep = 'DAY_0' | 'DAY_3' | 'DAY_6' | 'SUSPENDED';
export type SubscriptionStatus = 'ACTIVE' | 'TRIAL' | 'PAST_DUE' | 'SUSPENDED' | 'CANCELLED';

export interface DunningStatusDto {
  status: SubscriptionStatus;
  gracePeriodEndsAt: string | null;
  daysUntilSuspension: number | null;
  stepsSent: DunningStep[];
}

const QUERY_KEY = ['me', 'dunning-status'] as const;

export function useDunningStatus() {
  return useQuery<DunningStatusDto>({
    queryKey: QUERY_KEY,
    queryFn: () => api.get<DunningStatusDto>('/me/dunning-status'),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
